export const routes = {
  ROOT: '/',
  LOGIN: '/login',
  REQUEST_RESET_PASSWORD: '/request-reset-password',
  RESET_PASSWORD: '/reset-password',
  HOME: '/home',
  COMPANIES: '/companies',
  COMPANY_DETAILS_TABS: '/companies/:idSf/:tab?',
  COMPANY_CREATE: '/companies/create',
  USERS: '/users',
  USER_DETAILS_TABS: '/users/:idSf/:tab?',
  USER_CREATE: '/users/create',
  USER_TRANSACTION_DETAILS: '/users/:idSf/transactions/:transactionId/details',
  TRADING: '/trading',
  FINANCE: '/finance',
  FINANCE_TABS: '/finance/:tab?',
  FINANCE_ACCOUNTS_TABS: '/finance/accounts/:panel?',
  FINANCE_TRANSACTION_DETAILS: '/finance/transactions/:transactionId/details',
  SETTINGS: '/settings',
  SETTINGS_GENERAL: '/settings/general',
  SETTINGS_GENERAL_TABS: '/settings/general/:tab?',
  SETTINGS_ADMIN_USERS: '/settings/admin-users',
  SETTINGS_ADMIN_USERS_CREATE: '/settings/admin-users/create',
  SETTINGS_ADMIN_USERS_TABS: '/settings/admin-users/:tab?',
  SETTINGS_ASSETS: '/settings/assets',
  SETTINGS_ASSETS_TABS: '/settings/assets/:tab?',
  SETTINGS_ENTITIES: '/settings/entities',
  SETTINGS_ENTITY_CREATE: '/settings/entities/create',
  SETTINGS_ENTITY_DETAILS: '/settings/entities/:id',
  SETTINGS_ENTITY_DETAILS_TABS: '/settings/entities/:id/:tab?',
  SETTINGS_RULES: '/settings/rules',
  SETTINGS_RULES_TABS: '/settings/rules/:tab?',
}
